import { AsideBlock } from '~/app/_components/aside-block';
import type { DetailLink } from '~/app/_components/aside-block/aside-block';
import { SeriesListItem } from '~/app/_components/series-list-item';
import type { SeriesOverview } from '~/common/types/series-overview';
import { SeriesListPlaceHolderItem } from '@app/_components/series-list-placeholder-item';

const PLACEHOLDER_COUNT = 8;

type Props = {
  title: string;
  series: SeriesOverview[];
  showLoading?: boolean;
  detailLink?: DetailLink;
  showSensitive: boolean;
};

export const SeriesSelectionBlock = ({
  title,
  series,
  showLoading,
  detailLink,
  showSensitive,
}: Props) => {
  if (showLoading === true) {
    return (
      <AsideBlock title={title} detailLink={detailLink}>
        {[...Array.from({ length: PLACEHOLDER_COUNT })].map((_, idx) => {
          return (
            <SeriesListPlaceHolderItem key={`${title}-place-holder-${idx}`} />
          );
        })}
      </AsideBlock>
    );
  }

  if (series.length === 0) return null;

  return (
    <AsideBlock title={title} detailLink={detailLink}>
      {series.map((series, idx) => (
        <SeriesListItem
          key={idx}
          index={idx}
          series={series}
          showSensitive={showSensitive}
          config={{
            visibilities: {
              likes: true,
              user: true,
              tags: true,
              description: true,
            },
          }}
          marginLeft={{
            base: '0',
            lgDown: '-16px',
          }}
          analyticsParams={{
            sectionTitle: title,
          }}
          px="0"
        />
      ))}
    </AsideBlock>
  );
};
